module.exports = __webpack_public_path__ + "assets/521b3537e5c88903fcd264d9a02cc0cd.png";